import { useMemo } from 'react'

import { ISortSelectOption } from 'src/components/filter/types/filter.types'
import { useGetRewardActivityTypes } from './use-get-reward-activity-types.hook'
import { defaultSelect } from 'src/constants'

const useRewardActivityTypeOptions = () => {
  const { data: rewardActivityTypes, isLoading } = useGetRewardActivityTypes()

  const items = useMemo(() => {
    if (isLoading || !rewardActivityTypes) return [defaultSelect]

    const selectionValues: ISortSelectOption[] = rewardActivityTypes.map((type) => ({
      label: type?.replace(/_/g, ' '),
      value: type,
    }))

    selectionValues.unshift(defaultSelect)

    return selectionValues
  }, [isLoading, rewardActivityTypes])

  return { selectName: 'reward-activity-type-filter-title.v', queryParamName: 'type', items }
}

export { useRewardActivityTypeOptions }
